import { render, staticRenderFns } from "./HouseFundPurchaseInfo.vue?vue&type=template&id=412d5b9d&"
import script from "./HouseFundPurchaseInfo.vue?vue&type=script&lang=js&"
export * from "./HouseFundPurchaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports